var _rect, _path, _rect2, _rect3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 8.75,
    x: 21,
    y: 28.875,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M47.25 18.375 44.416 9.28a2 2 0 0 0-1.91-1.405H13.494a2 2 0 0 0-1.91 1.405L8.75 18.375"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 43.5,
    height: 4.125,
    x: 6.25,
    y: 43.875,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 2.063
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 43.5,
    height: 4.125,
    x: 6.25,
    y: 18.5,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 2.063
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M9.5 22.75v21m36.75-21v21M8.75 30.625h-1.5a2 2 0 0 0-2 2v1.25a2 2 0 0 0 2 2h1.5m37.625 0h1.5a2 2 0 0 0 2-2v-1.25a2 2 0 0 0-2-2h-1.5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlot);
export default __webpack_public_path__ + "static/media/plot.6c48319d13afb84ad449194972b5d4fd.svg";
export { ForwardRef as ReactComponent };